import hoverIntent from 'hoverintent';

(function ($) {
	var isTablet = setisTablet($(window).width());

	function setisTablet(width) {
		return width < 1074;
	}

	$(window).resize(function () {
		isTablet = setisTablet($(window).width());
	});

	//Remove item that added by 'Shortcode in menus' plugin.
	const body = document.body;
	const extraMenuItem = document.querySelector('.primary-menu .menu-item-object-gs_sim');
	extraMenuItem && extraMenuItem.remove();

	// Main menu hover
	let hoverTimeout;

	// Use hoverIntent for detecting hover state on menu
	document.querySelectorAll('#primary-menu').forEach(item => {
		hoverIntent(item, function () {
			if (!isTablet) {
				body.classList.add('menu-hovered');
				// item.classList.add('hovered');
			}
		}, function () {
			if (!isTablet) {
				body.classList.remove('menu-hovered');
				// item.classList.remove('hovered');
			}
		});
	});

	// Syncronize hover state with menu item hover
	document.querySelectorAll('#primary-menu>li.menu-item-has-children').forEach(item => {
		item.addEventListener('mouseenter', function () {
			if (!isTablet) {
				body.classList.contains('menu-hovered')
					? body.classList.add('menu-item-hovered')
					: hoverTimeout = setTimeout(function () {
						body.classList.add('menu-item-hovered');
					}, 200);
			}
		});
		item.addEventListener('mouseleave', function () {
			if (!isTablet) {
				clearTimeout(hoverTimeout);
				body.classList.remove('menu-item-hovered');
			}
		});
	});

	// Set menu css variables
	function hasSubMenu(menuItem) {
		return menuItem.find('ul').length > 0 ? true : false;
	}

	const menuItems = $('#primary-menu>li');
	if (menuItems.length > 0) {
		menuItems.each(function () {
			if (hasSubMenu($(this))) {
				const subMenu = $(this).find('ul');
				const subMenuTitle = $(this).find('a').first().text();
				subMenu.css("--title", '"' + subMenuTitle + '"');
			}
		});
	}

	//Mobile menu
	const menu = $('#primary-menu');
	const giftButton = menu.find('.btn').first();
	const giftLink = menu.find('.btn>a');
	const giftIcon = $('.navbar .get-bonus-icon');
	const hasGiftLink = giftLink.length > 0;

	//Set link href for git icon
	hasGiftLink && giftIcon.length > 0
		? giftIcon.attr('href', giftLink.attr('href'))
		: giftIcon.remove();

	if (giftButton.length > 0 && hasGiftLink) {
		giftButton.get(0).addEventListener('click', function (event) {
			giftLink.get(0).click();
		});
	}

	// Add sub levels artifacts
	$('<button class="menu-back-btn d-none">Tilbake</button>')
		.on('click', function () {
			window.setTimeout(function () {
				// Add delay to animate.
				menu.find('li.sub-menu-opened').last().removeClass('sub-menu-opened');
			}, 200);
			// console.log(menu.parents('.navbar'));
			menu.parents('.navbar').removeClass('show-level-2');
		})
		.prependTo($('.navbar>.container-xxl'));

	// Navigation to second level
	$("#primary-menu .menu-item-has-children > a").on('click', function (event) {
		if (isTablet) {
			event.preventDefault();

			$(this).parent().addClass('sub-menu-opened');
			menu.parents('.navbar').addClass('show-level-2');
			// console.log(menu.parents('.navbar'));
		}
	});

	//Mobile menu basic logic
	$('.navbar-toggler').on('click', function (event) {
		event.preventDefault();

		$('body').toggleClass('menu-open');
		$(this).attr('aria-expanded') === 'false'
			? $(this).attr('aria-expanded', 'true')
			: $(this).attr('aria-expanded', 'false');
		$('.menu-back-btn').trigger('click');
	});
}(jQuery));